import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_url } from "../config/config";
import { FaCheck, FaTimes, FaTrash, FaEye  } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeletePrompt from "../Components/common/DeletePrompt";
const ProductApproval = () => {
    const [products, setProducts] = useState([]);
    const [trigger, setTrigger] = useState(false);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewProduct, setViewProduct] = useState(null);
    
    const [showModal, setShowModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    const handleResetFilters = () => {
        setSearch("");
        setStartDate("");
        setEndDate("");
    };

    const fetchUpdateStatus = async (code, status, product_id, reason = "") => {
        try {
            const payload = {
                product_code: code,
                product_id,
                status,
            };

            if (status === "rejected") {
                payload.reject_reason = reason;
            }

            await axios.patch(`${api_url}/status/admin`, payload, {
               headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                },
            });

            setTrigger(prev => !prev);
        } catch (e) {
            console.error("Error updating status:", e);
            alert("Failed to update the status");
        }
    };

    
    const handleDeleteClick = (productId) => {
        setProductToDelete(productId);
        setShowDeleteModal(true);
    };

    
    const handleConfirmDelete = async () => {
        if (!productToDelete) return;
        try {
            const response = await axios.delete(`${api_url}/product/${productToDelete}`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("admin_token"),
                },
            });
            if (response.status === 200) {
                alert("Product deleted successfully");
                setTrigger(prev => !prev);
            } else {
                alert("Failed to delete the product");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("An error occurred while deleting the product.");
        }
        setShowDeleteModal(false);
        setProductToDelete(null);
    };


    const handleCancelDelete = () => {
        setShowDeleteModal(false);
        setProductToDelete(null);
    };

    const fetchProductStatus = async () => {
        try {
            const res = await axios.get(`${api_url}/pending/admin`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("admin_token"),
                },
            });
            setProducts(res.data.data);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        fetchProductStatus();
    }, [trigger]);

    const handleRejectClick = (product) => {
        setSelectedProduct(product);
        setShowModal(true);
        setRejectionReason("");
    };

    const handleRejectSubmit = () => {
        if (!rejectionReason.trim()) {
            alert("Please enter a reason for rejection.");
            return;
        }

        fetchUpdateStatus(
            selectedProduct.product_code,
            "rejected",
            selectedProduct.product_id,
            rejectionReason
        );

        setShowModal(false);
        setSelectedProduct(null);
        setRejectionReason("");
    };

    const filteredProducts = products.filter((product) => {
        const createdDate = new Date(product.created_at);
        const matchSearch =
            product.name?.toLowerCase().includes(search.toLowerCase()) ||
            product.product_code?.toLowerCase().includes(search.toLowerCase()) ||
            product.member_name?.toLowerCase().includes(search.toLowerCase());

        const matchStart = startDate ? createdDate >= new Date(startDate) : true;
        const matchEnd = endDate ? createdDate <= new Date(endDate) : true;

        return product.status === "pending" && matchSearch && matchStart && matchEnd;
    });


    return (
        <div className="container mx-auto p-4">
                <ToastContainer />
            <h1 className="text-2xl font-bold mb-4 text-center">Product Approval</h1>

            {/* Filters */}
            <div className="flex flex-wrap gap-4 mb-4 items-center justify-center">
                <input
                    type="text"
                    placeholder="Employee,Product name or code"
                    title="Employee,Product name or code"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border px-3 py-2 rounded w-64"
                />
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="border px-3 py-2 rounded"
                    max={new Date().toISOString().split("T")[0]}
                />
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="border px-3 py-2 rounded"
                    max={new Date().toISOString().split("T")[0]}
                />
                <button
                    onClick={handleResetFilters}
                    className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                >
                    Reset Filters
                </button>
            </div>

            {/* Table */}

            <div className="overflow-x-auto">
    <table className="table-auto min-w-max w-full border-collapse border border-gray-200">
        <thead>
            <tr className="bg-gray-100 text-left text-sm">
            <th className="border p-2">Employee Name</th>



                <th className="border p-2">Product Name</th>
                <th className="border p-2">Product Code</th>
                {/* <th className="border p-2">Description</th> */}
                <th className="border p-2">Product Type</th>
                {/* <th className="border p-2">Composition</th> */}
                <th className="border p-2">Pack Type</th>
                {/* <th className="border p-2">Consume Type</th> */}
                <th className="border p-2">Discount %</th>
                <th className="border p-2">Expire Date</th>
                {/* <th className="border p-2">Benefits</th>
                <th className="border p-2">How to Use</th>
                <th className="border p-2">Safety Advice</th> */}
                <th className="border p-2">Rx</th>
                {/* <th className="border p-2">Primary Use</th>
                <th className="border p-2">Storage Instruction</th>
                <th className="border p-2">Side Effects</th> */}
                <th className="border p-2">Return Policy</th>
                {/* <th className="border p-2">Alternatives</th>
                <th className="border p-2">Key Ingredients</th> */}
                <th className="border p-2">Shelf Rack No</th>
                <th className="border p-2">Category</th>
                {/* <th className="border p-2">Concern</th> */}
                <th className="border p-2">Manufacturer</th>
                {/* <th className="border p-2">Primary Image</th> */}
                {/* <th className="border p-2">Created At</th> */}
                <th className="border p-2">Price</th>
                <th className="border p-2">Actions</th>
            </tr>
        </thead>
        <tbody>
            {filteredProducts.map((product) => {
                const variant = product.variant?.[0] || {};
                return (
                    <tr key={product.product_id} className="text-sm">
                                    <td className="border p-2">{product.member_name || "N/A"}</td>

                        <td className="border p-2">{product.name || "N/A"}</td>
                        <td className="border p-2">{product.product_code || "N/A"}</td>
                        {/* <td className="border p-2">{product.description || "N/A"}</td> */}
                        <td className="border p-2">{product.product_type || "N/A"}</td>
                        {/* <td className="border p-2">{product.composition || "N/A"}</td> */}
                        <td className="border p-2">{product.pack_type || "N/A"}</td>
                        {/* <td className="border p-2">{product.consume_type || "N/A"}</td> */}
                        <td className="border p-2">{product.discount_percent || "N/A"}</td>
                        <td className="border p-2">{product.expire_date || "N/A"}</td>
                        {/* <td className="border p-2">{product.benefits || "N/A"}</td> */}
                        {/* <td className="border p-2">{product.how_to_use || "N/A"}</td> */}
                        {/* <td className="border p-2">{product.safety_advise || "N/A"}</td> */}
                        <td className="border p-2">{product.prescription_required || "N/A"}</td>
                        {/* <td className="border p-2">{product.primary_use || "N/A"}</td> */}
                        {/* <td className="border p-2">{product.storage_instruction || "N/A"}</td>
                        <td className="border p-2">{product.side_effects || "N/A"}</td> */}
                        <td className="border p-2">{product.return_policy || "N/A"}</td>
                        {/* <td className="border p-2">{product.alternatives || "N/A"}</td>
                        <td className="border p-2">{product.key_ingredients || "N/A"}</td> */}
                        <td className="border p-2">{product.shelf_rack_no || "N/A"}</td>
                        <td className="border p-2">
                            {product.category_ids?.map(cat => cat.category_name).join(", ") || "N/A"}
                        </td>
                        {/* <td className="border p-2">
                            {product.concern_ids?.map(concern => concern.concern_name).join(", ") || "N/A"}
                        </td> */}
                        <td className="border-2 p-2">
                            {product.Manufacturer ? (
                                <>
                                    {/* <img
                                        src={product.Manufacturer.image_url}
                                        alt={product.Manufacturer.name}
                                        className="w-8 h-8 object-cover rounded-full"
                                    /> */}
                                    <span>{product.Manufacturer.name}</span>
                                </>
                            ) : (
                                "N/A"
                            )}
                        </td>
                        {/* <td className="border p-2">
                            <img
                                src={product.product_images?.image_url?.primary_image}
                                alt="Primary"
                                className="w-16 h-8 object-cover"
                            />
                        </td> */}
                        {/* <td className="border p-2">
                            {new Date(product.created_at).toLocaleDateString()}
                        </td> */}
                        <td className="border p-2">{variant.price || "N/A"}</td>

                        <td className="border p-2 flex gap-2">
                            <button
                                className="bg-green-500 text-white p-2 rounded hover:bg-green-600"
                                onClick={() =>
                                    fetchUpdateStatus(product.product_code, "approved", product.product_id)
                                }
                                title="Approve"
                            >
                                <FaCheck />
                            </button>
                            <button
                                className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
                                onClick={() => handleRejectClick(product)}
                                title="Reject"
                            >
                                <FaTimes />
                            </button>
                            <button
                                className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600"
                                onClick={() => handleDeleteClick(product.product_id)}
                                title="Delete"
                            >
                                <FaTrash />
                            </button>
                            <button
    className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
    onClick={() => {
        setViewProduct(product);
        setShowViewModal(true);
    }}
    title="View"
>
    <FaEye />
</button>
                        </td>
                    </tr>
                );
            })}
            {filteredProducts.length === 0 && (
                <tr>
                    <td colSpan="26" className="text-center p-4 text-gray-500">
                        No matching products found.
                    </td>
                </tr>
            )}
        </tbody>
    </table>
</div>
{/* DeletePrompt modal for product delete */}
<DeletePrompt
    showModal={showDeleteModal}
    onDelete={handleConfirmDelete}
    onCancel={handleCancelDelete}
/> 
{/* modal for viewicon */}
{showViewModal && viewProduct && (
  <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-end z-50">
    <div className="relative bg-white p-6 pt-12 rounded-l-lg shadow-lg w-full max-w-md h-full overflow-y-auto animate-slide-in-right">
      {/* Close Button - Top Right */}
      <button
        className="fixed top-4 right-4 text-white hover:text-white bg-red-600 p-2 rounded-0 shadow"
        onClick={() => {
          setShowViewModal(false);
          setViewProduct(null);
        }}
      >
        ✕
      </button>

      <h2 className="text-xl font-semibold mb-4">Product Details</h2>

      <div className="grid grid-cols-1 gap-3 text-sm">
        <div><strong>Name:</strong> {viewProduct.name || "N/A"}</div>
        <div><strong>Code:</strong> {viewProduct.product_code || "N/A"}</div>
        <div><strong>Employee:</strong> {viewProduct.member_name || "N/A"}</div>
        {/* <div><strong>Type:</strong> {viewProduct.product_type || "N/A"}</div> */}
        <div><strong>Composition:</strong> {viewProduct.composition || "N/A"}</div>
        <div><strong>Pack Type:</strong> {viewProduct.pack_type || "N/A"}</div>
        <div><strong>Consume Type:</strong> {viewProduct.consume_type || "N/A"}</div>
        <div><strong>Discount %:</strong> {viewProduct.discount_percent ?? "N/A"}</div>
        <div><strong>Expire Date:</strong> {viewProduct.expire_date || "N/A"}</div>
        <div><strong>Prescription Required:</strong> {viewProduct.prescription_required || "No"}</div>
        <div><strong>Primary Use:</strong> {viewProduct.primary_use || "N/A"}</div>
        <div><strong>Return Policy:</strong> {viewProduct.return_policy || "N/A"}</div>
        <div><strong>Storage:</strong> {viewProduct.storage_instruction || "N/A"}</div>
        <div><strong>Shelf Rack No:</strong> {viewProduct.shelf_rack_no || "N/A"}</div>
        <div><strong>Side Effects:</strong> {viewProduct.side_effects || "N/A"}</div>
        <div><strong>How to Use:</strong> {viewProduct.how_to_use || "N/A"}</div>
        <div><strong>Safety Advise:</strong> {viewProduct.safety_advise || "N/A"}</div>
        <div><strong>Key Ingredients:</strong> {viewProduct.key_ingredients || "N/A"}</div>
        <div><strong>Status:</strong> {viewProduct.status || "N/A"}</div>
        {/* <div><strong>Reject Reason:</strong> {viewProduct.reject_reason || "N/A"}</div> */}
        <div><strong>Created At:</strong> {new Date(viewProduct.created_at).toLocaleString()}</div>
        <div><strong>Updated At:</strong> {new Date(viewProduct.updated_at).toLocaleString()}</div>
        <div><strong>Manufacturer:</strong> {viewProduct.Manufacturer?.name || "N/A"}</div>
        <div><strong>Categories:</strong> {viewProduct.category_ids?.map(c => c.category_name).join(", ") || "N/A"}</div>
        <div><strong>Concerns:</strong> {viewProduct.concern_ids?.map(c => c.concern_name).join(", ") || "N/A"}</div>
        <div><strong>Description:</strong> {viewProduct.description || "N/A"}</div>
        <div><strong>Benefits:</strong> {viewProduct.benefits || "N/A"}</div>
      </div>

      {/* Images */}
      <div className="mt-4">
        <h3 className="font-semibold">Primary Image:</h3>
        {viewProduct.product_images?.image_url?.primary_image ? (
          <img src={viewProduct.product_images.image_url.primary_image} alt="Primary" className="w-[200px] h-[200px] object-cover mt-2" />
        ) : "N/A"}
      </div>

      {viewProduct.product_images?.image_url?.additional_images?.length > 0 && (
        <div className="mt-4">
          <h3 className="font-semibold">Additional Images:</h3>
          <div className="flex flex-wrap gap-2 mt-2">
            {viewProduct.product_images.image_url.additional_images.map((url, idx) => (
              <img key={idx} src={url} alt={`Additional ${idx}`} className="w-20 h-20 object-cover rounded" />
            ))}
          </div>
        </div>
      )}

      {/* Variants */}
      {viewProduct.variant?.length > 0 && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Variants:</h3>
          <div className="space-y-2 text-sm">
            {viewProduct.variant.map((v, idx) => (
              <div key={idx} className="border p-2 rounded">
                <div><strong>Pack Size:</strong> {v.pack_size}</div>
                <div><strong>Product Size:</strong> {v.product_size}</div>
                <div><strong>Price:</strong> ₹{v.price}</div>
                <div><strong>Discounted Price:</strong> ₹{v.discounted_price}</div>
                <div><strong>Quantity:</strong> {v.quantity}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
)}





            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-lg w-full max-w-md">
                        <h2 className="text-xl font-semibold mb-4">Reason for Rejection</h2>
                        <textarea
                            rows={4}
                            className="w-full border p-2 rounded"
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter reason..."
                        ></textarea>
                        <div className="flex justify-end mt-4 space-x-2">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                                onClick={() => {
                                    setShowModal(false);
                                    setSelectedProduct(null);
                                    setRejectionReason("");
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                                onClick={handleRejectSubmit}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
               
        </div>
     
    );
};

export default ProductApproval;
